import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
export function Footer() {
  const t = useT();
  return <footer className="py-12 border-t border-white/10 transition-colors duration-300 bg-black" data-id="element-580">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-581">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-582">
          <div className="md:col-span-2" data-id="element-583">
            <Link to="/" className="inline-block mb-4" data-id="element-584">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-585" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-586">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-587">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-588">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-589">
              <li data-id="element-590">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-591">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-592">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-593">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-594">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-595">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-596">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-597">
              <li className="flex justify-between" data-id="element-598">
                <span data-id="element-599">{t('footer.monFri')}</span>
                <span data-id="element-600">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-601">
                <span data-id="element-602">{t('footer.saturday')}</span>
                <span data-id="element-603">7:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-604">
                <span data-id="element-605">{t('footer.sunday')}</span>
                <span data-id="element-606">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-607">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-608">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-609">
              <li data-id="element-610">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-611">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-612">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-613">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-614">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-615">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-616">
                <Link to="/diy-help" className="hover:text-white/70 transition-colors" data-id="element-617">
                  {t('footer.diyGuide')}
                </Link>
              </li>
              <li data-id="element-618">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-619">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-620">
          <p data-id="element-621">
            &copy; {new Date().getFullYear()} 253Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-622">
            <a href="#" className="hover:text-white transition-colors" data-id="element-623">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-624">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}